<!-- <section class="login-page-section-top ">

    <div class="container">
        <div class="row">
            <div class="col-md-12 size-img back-img">
                <div class="effect-cover">
                    <h3 class="txt-advert animated fadeInUp">ACADEMIES</h3>
                    <p class="txt-advert-sub animated">Want to start your tennis journey but unable to zero in on the
                        best one? Connect with more than 100 affiliated academies
                        across the nation to find the best-suited one for you! Special discounts for our app
                        subscribers!

                    </p>
                </div>
            </div>
        </div>
    </div>
    <div *ngFor="let banner of webBannerImageList"
        class="swiper-slide zoom-effect-container banner-image-div web-view-banner">
        <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
            <div class="headings image-card">
                <img [src]="banner.banner_image_src" class="product-image" alt="web banner" loading="lazy" />
                <div class="slider-inner-div">
                    <div class="container">
                        <div class="main-heading-banner">
                            <div class="sldier-bottom-section"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div *ngFor="let banner of mobileBannerImageList"
        class="swiper-slide zoom-effect-container banner-image-div mobile-view-banner">
        <div class="image-card-div" fxLayout="column" fxLayoutAlign="center center" fxFlexFill>
            <div class="headings image-card">
                <img [src]="banner.banner_image_src" class="product-image" alt="mobile banner" loading="lazy" />
                <div class="slider-inner-div">
                    <div class="container">
                        <div class="main-heading-banner">
                            <div class="sldier-bottom-section"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile_version-backbutton">
        <a class="mobile-header" onclick="history.back()">
            <i class="bx bx-chevron-left" style="color: #fff; font-size: 1.6em;"></i> Back </a>
    </div>
</section> -->
<div class="mobile_version-backbutton">
    <a class="mobile-header" onclick="history.back()">
        <span> <img src="../../../assets/images/tournament/backBtn.svg" alt="" loading="lazy"> </span>Academies </a>
</div>
<div class="topTitle">
    <h2>Academies</h2>
</div>
<section class="team Product-section academies-details-list">
    <div class="container aos-init aos-animate" data-aos="fade-up">
        <div class="row">
            <div class="col-md-3  leftFilters-div">
                <div class="filter-sidebar">
                    <div class="filter-header">
                        <span class="filter-title">Filters</span>
                        <a class="clear-filter" (click)="clearState()">Clear filter</a>
                    </div>
                    <p-accordion [multiple]="true" class="filter-accordion" [activeIndex]="[0,2]">
                        <p-accordionTab header="State">
                            <div class="filterBody">
                                <div class="filterHeader">
                                    <div class="searchbar">
                                        <input pInputText type="text" placeholder="Search for State"
                                            [(ngModel)]="searchedStateName" (input)="onSearchState($event)"
                                            class="search-input" />
                                        <div class="icon">
                                            <img src="../../../assets/images/tournament/filterSearch.svg" alt=""
                                                loading="lazy">
                                        </div>
                                    </div>
                                </div>
                                <!-- Skeleton for filter list -->
                                <div class="filterMainList" *ngIf="isLoadingFilters">
                                    <div *ngFor="let item of [1,2,3,4,5]" class="filterList skeleton-filter-item">
                                        <p-skeleton width="18px" height="18px" borderRadius="4px"></p-skeleton>
                                        <p-skeleton width="70%" height="14px" borderRadius="4px"
                                            styleClass="ml-2"></p-skeleton>
                                    </div>
                                </div>
                                <div class="filterMainList" *ngIf="!isLoadingFilters">
                                    <div *ngFor="let state of states; trackBy: trackByState" class="filterList">
                                        <p-checkbox [value]="state" [(ngModel)]="selectedState" [binary]="false"
                                            (onChange)="onStateSelect($event)"></p-checkbox>
                                        <label for="selectedAges">{{ state.name }}</label>
                                    </div>
                                </div>
                            </div>
                        </p-accordionTab>

                        <p-accordionTab header="City">
                            <div class="filterBody">
                                <div class="filterHeader">
                                    <div class="searchbar">
                                        <input pInputText type="text" placeholder="Search for City"
                                            [(ngModel)]="searchedCityName" (input)="onSearchCity($event)"
                                            class="search-input" />
                                        <div class="icon">
                                            <img src="../../../assets/images/tournament/filterSearch.svg" alt=""
                                                loading="lazy">
                                        </div>
                                    </div>
                                </div>
                                <!-- Skeleton for filter list -->
                                <div class="filterMainList" *ngIf="isLoadingFilters">
                                    <div *ngFor="let item of [1,2,3,4,5]" class="filterList skeleton-filter-item">
                                        <p-skeleton width="18px" height="18px" borderRadius="4px"></p-skeleton>
                                        <p-skeleton width="70%" height="14px" borderRadius="4px"
                                            styleClass="ml-2"></p-skeleton>
                                    </div>
                                </div>
                                <div class="filterMainList" *ngIf="!isLoadingFilters">
                                    <div *ngFor="let city of cityList; trackBy: trackByCity" class="filterList">
                                        <p-checkbox [value]="city" [(ngModel)]="selectedCity" [binary]="false"
                                            (onChange)="onCitySelect($event)"></p-checkbox>
                                        <label for="selectedAges">{{ city.name }}</label>
                                    </div>
                                </div>
                            </div>
                        </p-accordionTab>

                        <p-accordionTab header="Surface">
                            <div class="filterBody pt-2">
                                <div class="filterMainList">
                                    <div class="filterList">
                                        <p-checkbox binary="true" [(ngModel)]="grassVal"
                                            (onChange)="setGrass($event)"></p-checkbox>
                                        <label for="selectedAges">Grass</label>
                                    </div>
                                    <div class="filterList">
                                        <p-checkbox binary="true" [(ngModel)]="clayVal"
                                            (onChange)="setClay($event)"></p-checkbox>
                                        <label for="selectedAges">Clay</label>
                                    </div>
                                    <div class="filterList">
                                        <p-checkbox binary="true" [(ngModel)]="hardVal"
                                            (onChange)="setHard($event)"></p-checkbox>
                                        <label for="selectedAges">Hard/ Synthetic</label>
                                    </div>
                                </div>
                            </div>
                        </p-accordionTab>

                        <!-- <p-accordionTab header="Level">
                            <div class="filterBody">
                                <div class="filterMainList">
                                    <div class="filterList">
                                        <p-checkbox binary="true"></p-checkbox>
                                        <label for="selectedAges">Beginner</label>
                                    </div>
                                    <div class="filterList">
                                        <p-checkbox binary="true"></p-checkbox>
                                        <label for="selectedAges">Intermediate</label>
                                    </div>
                                    <div class="filterList">
                                        <p-checkbox binary="true"></p-checkbox>
                                        <label for="selectedAges">Advanced</label>
                                    </div>
                                    <div class="filterList">
                                        <p-checkbox binary="true"></p-checkbox>
                                        <label for="selectedAges">Personal Training</label>
                                    </div>
                                </div>
                            </div>
                        </p-accordionTab> -->

                        <!-- <p-accordionTab header="Month">
                <div class="filterBody">
                  <div class="filterMainList">
                    <div *ngFor="let  month of monthlist" class="filterList">
                      <p-checkbox [value]="month" [binary]="false"></p-checkbox>
                      <label for="selectedAges">{{month }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Date">
                <div class="filterBody dateRange">
                  <div class="filterMainList">
                    <div class="d-flex">
                      <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"
                        dateFormat="dd/mm/yy" appendTo="body" placeholder="Select Date" (onSelect)="selectDateRange()">
                      </p-calendar>
                      <button pButton label="Clear" title="Clear" class="p-button p-ml-2 p-mb-0" style="color: #fff!important;
                    padding: 6px 0px;
                    width: 30%" (click)="clear()"></button>
                    </div>
                  </div>
                </div>
              </p-accordionTab>
              <p-accordionTab header="Surface">
                <div class="filterBody">
                  <div class="filterHeader">
                    <div class="searchbar">
                      <input pInputText type="text" placeholder="Search for surface" [(ngModel)]="ageFilter"
                        class="search-input" />
                      <div class="icon">
                        <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                      </div>
                    </div>
                  </div>
                  <div class="filterMainList">
                    <div *ngFor="let court of courtTypeList" class="filterList">
                      <p-checkbox [value]="court" [binary]="false"></p-checkbox>
                      <label for="selectedAges">{{ court.label }}</label>
                    </div>
                  </div>
                </div>
              </p-accordionTab> -->
                    </p-accordion>

                    <!-- <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Select State</h6>
                        </div>

                        <div class="sellers d-flex">
                            <p-dropdown inputId="state" [showClear]="true" [options]="states" placeholder="Select"
                                [filter]="true" (onChange)="setState($event)" optionLabel="name"
                                (onClear)="clearState()"></p-dropdown>
                         
                        </div>

                    </div>
                    <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Select City</h6>
                        </div>


                        <div class="sellers d-flex">
                           
                            <p-dropdown inputId="city" [options]="cityList" [filter]="true" [showClear]="true"
                                placeholder="Select City" optionLabel="name" (onChange)="onCitySelect($event)"
                                (onClear)="clearCity()"></p-dropdown>
                         
                        </div>
                    </div>
                    <div class="fliter-div">

                        <div class="col-md-12">
                            <h6>Court</h6>
                        </div>
                        <div class="aminites available-section ">
                            <ul>
                                <li>
                                    <span> <p-checkbox binary="true" (onChange)="setHard($event)"></p-checkbox> </span>
                                    Hard/ Synthetic
                                </li>
                                <li>
                                    <span><p-checkbox binary="true" (onChange)="setGrass($event)"></p-checkbox> </span>
                                    Grass
                                </li>
                                <li>
                                    <span><p-checkbox binary="true" (onChange)="setClay($event)"></p-checkbox> </span>
                                    Clay
                                </li>
                            </ul>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="col-md-9 academicslider">
                <div class="row">
                    <div class="col-md-12 right-section-top-bar">

                        <div class="searchTournament">
                            <div class="searchBar">
                                <input type="text" placeholder="Search Academies"
                                    (input)="onSearchAcademy($event.target.value)" />
                                <img src="../../../assets/images/tournament/search.svg" alt="" class="icon">
                            </div>
                            <div class="shortBtn" (click)="onDownloadClick('bottom')">
                                <button>
                                    <div class="icon">
                                        <img src="../../../assets/images/tournament/sort.svg" alt="">
                                    </div>
                                    <div class="title">
                                        Sort
                                    </div>
                                </button>
                            </div>
                            <div class="shortBtn mobileFilters">
                                <button (click)="showMobileFilter()">
                                    <div class="icon">
                                        <img src="../../../assets/images/tournament/Filter.svg" alt="">
                                    </div>
                                    <div class="title">
                                        FILTER
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="totalTitle">
                            <h4> Academies <span class="count">{{totalAcademyRecords }}</span></h4>
                        </div>
                    </div>
                    <div class="mainListDiv">
                        <!-- ===== SKELETON LOADER FOR ACADEMY CARDS ===== -->
                        <ng-container *ngIf="isLoadingAcademies">
                            <div class="col-md-4 col-sm-6 mainAcacmeyListBox" *ngFor="let item of skeletonCards">
                                <div class="swiper-slide mainSliderDiv shadow-slide swiper-slide--one skeleton-card">
                                    <div class="acadmy-list-div">
                                        <div class="topDetails">
                                            <div class="imageslider">
                                                <img src="../../../../assets/img/lazyload/lazyLoad.webp" alt="">
                                                <!-- <p-skeleton width="100%" height="200px"
                                                    borderRadius="12px 12px 0 0"></p-skeleton> -->
                                            </div>
                                            <div class="acadmeyuserDetails" style="padding: 12px;">
                                                <div class="mainDiv">
                                                    <div class="leftDiv">
                                                        <div class="userImage">
                                                            <p-skeleton shape="circle" size="40px"></p-skeleton>
                                                        </div>
                                                        <div class="userDetails" style="margin-left: 10px;">
                                                            <p-skeleton width="140px" height="16px" borderRadius="4px"
                                                                styleClass="mb-2"></p-skeleton>
                                                            <p-skeleton width="90px" height="12px"
                                                                borderRadius="4px"></p-skeleton>
                                                        </div>
                                                    </div>
                                                    <div class="review-ui">
                                                        <p-skeleton width="50px" height="20px"
                                                            borderRadius="4px"></p-skeleton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="footerListButton" style="padding: 12px;">
                                            <div class="btn1" style="flex: 1;">
                                                <p-skeleton width="100%" height="36px" borderRadius="8px"></p-skeleton>
                                            </div>
                                            <div class="btn2" style="flex: 1; margin-left: 8px;">
                                                <p-skeleton width="100%" height="36px" borderRadius="8px"></p-skeleton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <!-- ===== ACTUAL ACADEMY CARDS ===== -->
                        <ng-container *ngIf="!isLoadingAcademies">
                            <div class="col-md-4 col-sm-6 mainAcacmeyListBox"
                                *ngFor="let academy of academiesList; trackBy: trackByAcademy">

                                <div class="swiper-slide  mainSliderDiv shadow-slide swiper-slide--one"
                                    (click)="onDownloadClick('bottom')">

                                    <div class="acadmy-list-div">
                                        <div class="topDetails">
                                            <div class="imageslider">
                                                <swiper
                                                    class="swiper-container images-slider zoom-effect-container desktop-slider"
                                                    fxFlex="auto" [config]="Top_config" [disabled]="disabled"
                                                    (indexChange)="onIndexChange($event)"
                                                    (swiperTransitionStart)="onSwiperEvent('transitionStart')"
                                                    *ngIf="academy?.slider_image && academy.slider_image.length > 0; else f2"
                                                    (swiperTransitionEnd)="onSwiperEvent('transitionEnd')">
                                                    <div *ngFor="let academyimage of academy?.slider_image; trackBy: trackByImage"
                                                        class="swiper-slide imageslider zoom-effect-container">
                                                        <div class="image-card-div" fxLayout="column"
                                                            fxLayoutAlign="center center" fxFlexFill>
                                                            <div class="headings image-card">
                                                                <img [src]="academyimage?.slider_image_src"
                                                                    [defaultImage]="'assets/img/lazyload/lazyLoad.png'"
                                                                    [lazyLoad]="academyimage?.slider_image_src"
                                                                    class="product-image" alt="banner" loading="lazy" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </swiper>
                                                <ng-template #f2>
                                                    <img src="../../../../assets/img/lazyload/lazyLoad.webp" alt="image"
                                                        loading="lazy">
                                                </ng-template>
                                                <div class="packageTag">
                                                    <div class="text">{{academy.membershipType}}</div>
                                                </div>
                                            </div>
                                            <div class="acadmeyuserDetails">
                                                <div class="mainDiv">
                                                    <div class="leftDiv">
                                                        <div class="userImage">
                                                            <img [src]="(academy.academypic) ? academy.academypic : '../../../../assets/images/academy_dummy.jpg'"
                                                                alt="" loading="lazy">
                                                        </div>
                                                        <div class="userDetails">
                                                            <h2>{{academy.name}}</h2>
                                                            <p> <img src="../../../../assets/images/academe/locationTag.svg"
                                                                    alt="" loading="lazy"> {{academy.cityname}}</p>
                                                        </div>
                                                    </div>

                                                    <div class="review-ui">
                                                        <div style=" background-color: transparent!important; "> <img
                                                                src="../../../../assets/images/academe/star.svg" alt=""
                                                                loading="lazy"> {{academy.academyAvgReview?.toFixed(1)}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="footerListButton">
                                            <div class="btn1">
                                                <!-- <button (click)="oncickdetails(academy.id)">
                                                <span>ENROLL NOW</span>
                                            </button> -->
                                                <button (click)="onDownloadClick('bottom')">
                                                    <span>ENROLL NOW</span>
                                                </button>
                                            </div>
                                            <div class="btn2">
                                                <button (click)="onDownloadClick('bottom')">
                                                    <span>KNOW MORE</span>
                                                </button>
                                            </div>
                                        </div>
                                        <!-- <div class="image-div">
                                    <img [src]="(academy.academypic) ? academy.academypic : '../../../../assets/images/academy_dummy.jpg'"
                                        alt="">
                                </div> -->
                                        <!-- <div class="col-header">
                                        <h2 class="text-center">{{academy.name}}</h2>
                                    </div>
                                    <div class="location-div">
                                        <p>
                                            <em>
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z">
                                                    </path>
                                                </svg>
                                                <em>
                                                    {{academy.cityname}}</em>
                                            </em>

                                            <button class="member-button {{academy.membershipType}}">
                                                {{academy.membershipType}}</button>
                                        </p>



                                        <div class="review-ui">
                                            <span
                                                style=" background-color: transparent!important; ">{{academy.academyAvgReview?.toFixed(1)}}
                                                <i class="pi pi-star-fill "></i> </span>
                                        </div>
                                    </div> -->

                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <!---Contest Main List End--->
                    <div class="contest-pagination">
                        <!-- <div class="p-d-flex p-ai-center p-jc-between">
                            In total there are
                            {{totalAcademyRecords }} Academy.
                        </div> -->
                        <div class="pagination-div" *ngIf="totalAcademyRecords > 0">

                            <p-paginator *ngIf="totalAcademyRecords > 0" [rows]="pageLimitFirst" #paginator
                                class="paginater" pageLinkSize="3" [totalRecords]="totalAcademyRecords"
                                (onPageChange)="loadAcademies($event, mode)"
                                [first]="(pageNumberFirst - 1) * pageLimitFirst" [rowsPerPageOptions]=" pagination"
                                appendTo="body"></p-paginator>

                        </div>
                        <div *ngIf="totalAcademyRecords == 0" class="not-found-sectionMainDiv">

                            <div class="not-found-section">
                                <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                                    <h4>No Academy Available!</h4>
                                    <p>Please check back later for updates or explore other ongoing
                                        Academy.</p>
                                </div>
                            </div>
                        </div>
                    </div>



                    <!-- <p-paginator *ngIf="totalRecords > 0" [rows]="9" #paginator [totalRecords]="totalRecords"
                        (onPageChange)="loadAcademies($event)" [rowsPerPageOptions]=" pagination"></p-paginator>
                    <div *ngIf="totalRecords == 0">
                       
                        <div class="not-found-section">
                            <div class="col-md-12 not-found-body"><img src="assets/img/logo/not-found.gif" alt="">
                              <h4>No Academy Available!</h4>
                              <p>Please check back later for updates or explore other ongoing
                                Academy.</p>
                            </div>
                          </div>
                    </div>
                    -->
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">

                <div class="col-md-12 main-title">
                    <h4> <span><i class="bx bx-filter-alt"></i></span> Filters</h4>
                </div>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body mobilefilter">
                <div class="col-md-12  p-p-0 left-side-bar-filter " style="display: block!important;">
                    <div class="left-side-section" style="box-shadow: none!important;">


                        <div class="fliter-div">

                            <div class="col-md-12">
                                <h6>Select State</h6>
                            </div>

                            <div class="sellers d-flex">
                                <p-dropdown inputId="state" [showClear]="true" [options]="states" placeholder="Select"
                                    [filter]="true" (onChange)="setState($event)" optionLabel="name"></p-dropdown>
                                <!-- <select name="type" id="type" class="mb-3 w-100 border p-2 focus:outline-none">
                                    <option value="" selected="">Select State</option>
                                    <option value="red">Andhra Pradesh</option>
                                    <option value="blue">Arunachal Pradesh</option>
                                    <option value="green">Assam</option>
                                    <option value="green">Goa</option>
                                    <option value="green">Gujarat</option>
                                    <option value="green">Haryana</option>
                                    <option value="green">Kerala</option>
                                    <option value="green">Maharashtra</option>
                                    <option value="green">Manipur</option>
                                    <option value="green">Meghalaya</option>
                                    <option value="green">Rajasthan</option>
                                </select> -->
                            </div>

                        </div>
                        <div class="fliter-div">

                            <div class="col-md-12">
                                <h6>Select City</h6>
                            </div>


                            <div class="sellers d-flex">
                                <!-- <p-dropdown inputId="city" [showClear]="true" [options]="cities" placeholder="Select"
                                    [filter]="true" (onClear)="onClickCity($event)" (onChange)="onClickCity($event)"
                                    optionLabel="name"></p-dropdown> -->
                                <p-dropdown inputId="city" [options]="cityList" [filter]="true" [showClear]="true"
                                    placeholder="Select City" optionLabel="name"
                                    (onChange)="onCitySelect($event)"></p-dropdown>
                                <!-- <select name="type" id="type" class="mb-3  border p-2 focus:outline-none w-100 ">
                                    <option selected="">Select City</option>
                                    <option>Mumbai</option>
                                    <option value="1">Pune</option>
                                    <option value="2">Vadodara</option>
                                    <option value="3">Hyderabad</option>
                                    <option value="3">Delhi</option>
                                    <option value="3">Bengaluru</option>
                                    <option value="3">Chennai</option>
    
                                </select> -->
                            </div>
                        </div>
                        <div class="fliter-div">

                            <div class="col-md-12">
                                <h6>Court</h6>
                            </div>
                            <div class="aminites available-section ">
                                <ul>
                                    <li>
                                        <span> <p-checkbox binary="true" (onChange)="setHard($event)"></p-checkbox>
                                        </span>
                                        Hard/ Synthetic
                                    </li>
                                    <li>
                                        <span><p-checkbox binary="true" (onChange)="setGrass($event)"></p-checkbox>
                                        </span>
                                        Grass
                                    </li>
                                    <li>
                                        <span><p-checkbox binary="true" (onChange)="setClay($event)"></p-checkbox>
                                        </span>
                                        Clay
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
            <div class="modal-footer">

                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Submit</button>
            </div>
        </div>
    </div>
</div>


<p-dialog [closable]="true" [(visible)]="downloadModal" [style]="{width: '416px'}" id="downloadModalPopup"
    [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [baseZIndex]="10000" [draggable]="false"
    [resizable]="false" [closable]="false" [position]="position" [modal]="true">
    <div class="downloadbody">
        <div class="topleftbg">
            <img src="../../../../assets/images/download/topleft.png" alt="">
        </div>
        <div class="bottomrightbg">
            <img src="../../../../assets/images/download/bottomright.png" alt="">
        </div>
        <div class="bottomleftbg">
            <img src="../../../../assets/images/download/bottomleft.png" alt="">
        </div>
        <div class="download-header">
            <button (click)="downloadModal = false" class="closeBtn">
                <img src="assets/images/download/close.svg" alt="">
            </button>
        </div>
        <div class="bannerImage">
            <img src="../../../../assets/images/download/leander.png" alt="">
        </div>
        <div class="modalTitleImage">
            <img src="../../../../assets/images/download/modalTile.svg" alt="">
        </div>

        <div class="downloadList">
            <ul>
                <li>
                    <a href="https://play.google.com/store/apps/details?id=com.wiantech.tplsport&pcampaignid=web_share">
                        <img src="../../../../assets/images/download/btn1.png" alt="">
                    </a>
                </li>
                <li>
                    <a href="https://apps.apple.com/in/app/tpl-tennis-premier-league/id6461867254">
                        <img src="../../../../assets/images/download/btn2.png" alt="">
                    </a>
                </li>
            </ul>
        </div>

        <div class="orTitle">
            <div class="line"></div>
            <p>OR</p>
            <div class="line"></div>
        </div>
        <div class="scanner">
            <img src="../../../../assets/images/download/qrcode.png" alt="">
        </div>
        <div class="notesdiv">
            <p>Click the buttons above to download the <span>App!</span></p>
        </div>
    </div>
</p-dialog>


<p-dialog id="mobileFilter" [(visible)]="mobilFilter" [breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }"
    [style]="{ width: '400px' }" [modal]="true" [draggable]="false" [resizable]="false" [closable]="false">
    <ng-template pTemplate="header">
        <div class="filterHeader">
            <div class="title">
                <h6>Filters</h6>
            </div>
            <div class="close">
                <button pButton type="button" icon="pi pi-times" (click)="mobilFilter = false"></button>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <div class="card filterTab">

            <p-tabView [(activeIndex)]="activeIndex">

                <p-tabPanel header="State">
                    <div class="filterBody">
                        <div class="titleTable">
                            <h6>FILTER BY</h6>
                        </div>
                        <div class="filterHeader">
                            <div class="searchbar">
                                <input pInputText type="text" placeholder="Search for State"
                                    [(ngModel)]="searchedStateName" (input)="onSearchState($event)"
                                    class="search-input" />
                                <div class="icon">
                                    <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="filterMainList">
                            <div *ngFor="let state of states" class="filterList">
                                <p-checkbox [value]="state" [(ngModel)]="selectedState" [binary]="false"
                                    (onChange)="onStateSelect($event)"></p-checkbox>
                                <label for="selectedAges">{{ state.name }}</label>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="City">
                    <div class="filterBody">
                        <div class="titleTable">
                            <h6>FILTER BY</h6>
                        </div>
                        <div class="filterHeader">
                            <div class="searchbar">
                                <input pInputText type="text" placeholder="Search for City"
                                    [(ngModel)]="searchedCityName" (input)="onSearchCity($event)"
                                    class="search-input" />
                                <div class="icon">
                                    <img src="../../../assets/images/tournament/filterSearch.svg" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="filterMainList">
                            <div *ngFor="let city of cityList" class="filterList">
                                <p-checkbox [value]="city" [(ngModel)]="selectedCity" [binary]="false"
                                    (onChange)="onCitySelect($event)"></p-checkbox>
                                <label for="selectedAges">{{ city.name }}</label>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Surface">
                    <div class="filterBody pt-2">
                        <div class="titleTable">
                            <h6>FILTER BY</h6>
                        </div>
                        <div class="filterMainList">
                            <div class="filterList">
                                <p-checkbox binary="true" [(ngModel)]="grassVal"
                                    (onChange)="setGrass($event)"></p-checkbox>
                                <label for="selectedAges">Grass</label>
                            </div>
                            <div class="filterList">
                                <p-checkbox binary="true" [(ngModel)]="clayVal"
                                    (onChange)="setClay($event)"></p-checkbox>
                                <label for="selectedAges">Clay</label>
                            </div>
                            <div class="filterList">
                                <p-checkbox binary="true" [(ngModel)]="hardVal"
                                    (onChange)="setHard($event)"></p-checkbox>
                                <label for="selectedAges">Hard/ Synthetic</label>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="Level">
                    <div class="filterBody">
                        <div class="titleTable">
                            <h6>FILTER BY</h6>
                        </div>
                        <div class="filterMainList">
                            <div class="filterList">
                                <p-checkbox binary="true"></p-checkbox>
                                <label for="selectedAges">Beginner</label>
                            </div>
                            <div class="filterList">
                                <p-checkbox binary="true"></p-checkbox>
                                <label for="selectedAges">Intermediate</label>
                            </div>
                            <div class="filterList">
                                <p-checkbox binary="true"></p-checkbox>
                                <label for="selectedAges">Advanced</label>
                            </div>
                            <div class="filterList">
                                <p-checkbox binary="true"></p-checkbox>
                                <label for="selectedAges">Personal Training</label>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
            </p-tabView>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="mainBtn">
            <div class="footerBtn">
                <button class="canelBtn" pButton type="button" label="CLEAR FILTER"
                    (click)="clearState(); mobilFilter = false"></button>
                <button class="applyBtn" pButton type="button" label="APPLY" (click)="mobilFilter = false"></button>
            </div>
        </div>

    </ng-template>

</p-dialog>